module.exports = __webpack_public_path__ + "img/11.ca7b238c.jpg";